
let text1 = 'a'
let text100 = 'aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa'
let text101 = 'aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa'
let text1000 = 'aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa'
let text1001 = 'aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa'
let text2500 = 'aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa'
let text2501 = 'aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa'
let textspecial = `start ~!@#$%^&*()-_=+[]{}|;:'",.<>/? end`

const testfragments = {

	text1: text1,
	text100: text100,
	text101: text101,
	text1000: text1000, 
	text1001: text1001, 
	text2500: text2500, 
	text2501: text2501, 
	textspecial: textspecial,

	string: {
		propertyId: "<<UUID>>",
		name: "string",
		pname: "string",
		subType: "string",
		type: "string",
		control: "text",
		maxLength: 1000,
	},

	string_multi: {
		propertyId: "<<UUID>>",
		name: "string multi",
		pname: "string_multi",
		subType: "string_multi",
		type: "string",
		control: "textarea",
		maxLength: 2500
	},
		
	dropdown_multi: {
		propertyId: "<<UUID>>",
		name: "dropdown multi",
		pname: "dropdown_multi",
		subType: "dropdown_multi",
		type: "array",
		control: "dropdownmulti",
		uniqueItems: true,
		maxItems: 100,
		items: {
			subType: "string",
			type: "string",
			control: "checkbox",
			maxLength: 100,
			enum: ["Option 1", "Option 2", "Option 3"],
		}
	},

	list_multi: {
		propertyId: "<<UUID>>",
		name: "list multi",
		pname: "list_multi",
		subType: "list_multi",
		type: "array",
		control: "listmulti",
		uniqueItems: true,
		maxItems: 100,
		items: {
			subType: "string",
			type: "string",
			control: "checkbox",
			maxLength: 100,
			enum: ["Option 1", "Option 2", "Option 3"],
		}
	},

	list_single: {
		propertyId: "<<UUID>>",
		name: "list single",
		pname: "list_single",
		subType: "list_single",
		type: "string",
		control: "radio",
		enum: ["Option 1", "Option 2", "Option 3"],
		maxLength: 100,
	},

	dropdown_single: {
		propertyId: "<<UUID>>",
		name: "dropdown single",
		pname: "dropdown_single",
		subType: "dropdown_single",
		type: "string",
		control: "dropdownsingle",
		enum: ["Option 1", "Option 2", "Option 3"],
		maxLength: 100,
	},
	 
	telephone: {
		propertyId: "<<UUID>>",
		name: "telephone",
		pname: "telephone",
		subType: "telephone",
		type: "string",
		control: "text",
		pattern: "^\\+?\\d{0,1}?(\\s|\\-|.)\\(?\\d+\\)?(\\s|\\-|.)?\\d{1,3}(\\s|\\-|\\.)?\\d{4}$",
		placeholder: "(999)999-9999",
		maxLength: 100,
	},
	
	email: {
		propertyId: "<<UUID>>",
		name: "email",
		pname: "email",
		subType: "email",
		type: "string",
		control: "text",
		pattern: "^(\\D)+(\\w)*((\\.(\\w)+)?)+@(\\D)+(\\w)*((\\.(\\D)+(\\w)*)+)?(\\.)[a-z]{2,}$",
		placeholder: "id@example.com",
		maxLength: 200,
	},

	usstateabbrev: {
		propertyId: "<<UUID>>",
		name: "state",
		pname: "state",
		subType: "usstateabbrev",
		type: "string",
		control: "text",
		enum: ["AL", "AK", "AS", "AZ", "AR", "CA", "CO", "CT", "DE", "DC", "FM", "FL", "GA", "GU", "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MH", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ", "NM", "NY", "NC", "ND", "MP", "OH", "OK", "OR", "PW", "PA", "PR", "RI", "SC", "SD", "TN", "TX", "UT", "VT", "VI", "VA", "WA", "WV", "WI", "WY"],
		placeholder: "CA",
		maxLength: 2,
	},

	uszipcode: {
		propertyId: "<<UUID>>",
		name: "zipcode",
		pname: "zipcode",
		subType: "uszipcode",
		type: "string",
		control: "text",
		pattern: "(^(?!0{5})(\\d{5})(?!-?0{4})(|-\\d{4})?$)",
		placeholder: "00000-0000",
		maxLength: 10,
	},

	number: {
		propertyId: "<<UUID>>",
		name: "number",
		pname: "number",
		subType: "number",
		type: "number",
		control: "number",
		pattern: "^(0|[1-9][0-9]*)$",
		mask: "999999999999999",
		maxLength: 1000,
		maximum: 999999999999999,
	},

	object: {
		propertyId: "<<UUID>>",
		name: "object",
		pname: "object",
		subType: "object",
		type: "object",
		control: "object",
		maxProperties: 10,
		properties: [
			{
				propertyId: "<<UUID>>",
				name: "text1a",
				pname: "text1a",
				subType: "string",
				type: "string",
				control: "text",
				maxLength: 1000,
			}, 
			{
				propertyId: "<<UUID>>",
				name: "text1b",
				pname: "text1b",
				subType: "string",
				type: "string",
				control: "text",
				maxLength: 1000,
			}
		]
	},

	object_max: {
		propertyId: "<<UUID>>",
		name: "object",
		pname: "object",
		subType: "object",
		type: "object",
		control: "object",
		maxProperties: 10,
		properties: [
			{
				propertyId: "<<UUID>>",
				name: "object",
				pname: "object",
				subType: "object",
				type: "object",
				control: "object",
				maxProperties: 10,
				properties: [
					{
						propertyId: "<<UUID>>",
						name: "object",
						pname: "object",
						subType: "object",
						type: "object",
						control: "object",
						maxProperties: 10,
						properties: [
							{
								propertyId: "<<UUID>>",
								name: "text1a",
								pname: "text1a",
								subType: "string",
								type: "string",
								control: "text",
								maxLength: 1000,
							}, 
							{
								propertyId: "<<UUID>>",
								name: "text1b",
								pname: "text1b",
								subType: "string",
								type: "string",
								control: "text",
								maxLength: 1000,
							}
						]
					}
				]
			},
		]
	},

	object_overmax: {
		propertyId: "<<UUID>>",
		name: "object",
		pname: "object",
		subType: "object",
		type: "object",
		control: "object",
		maxProperties: 10,
		properties: [
			{
				propertyId: "<<UUID>>",
				name: "object",
				pname: "object",
				subType: "object",
				type: "object",
				control: "object",
				maxProperties: 10,
				properties: [
					{
						propertyId: "<<UUID>>",
						name: "object",
						pname: "object",
						subType: "object",
						type: "object",
						control: "object",
						maxProperties: 10,
						properties: [
							{
								propertyId: "<<UUID>>",
								name: "object",
								pname: "object",
								subType: "object",
								type: "object",
								control: "object",
								maxProperties: 10,
								properties: [
									{
										propertyId: "<<UUID>>",
										name: "text1a",
										pname: "text1a",
										subType: "string",
										type: "string",
										control: "text",
										maxLength: 1000,
									}, 
									{
										propertyId: "<<UUID>>",
										name: "text1b",
										pname: "text1b",
										subType: "string",
										type: "string",
										control: "text",
										maxLength: 1000,
									}
								]
							}
						]
					}
				]
			},
		]
	},

	json: {
		propertyId: "<<UUID>>",
		name: "json",
		pname: "json",
		subType: "json",
		type: "string",
		control: "text",
		maxLength: 1000,
	},


// Fragments

	propertyFragment: `properties {
		items {validationErrors {error warning data}}
		validationErrors {error warning data}
		properties {
			items {validationErrors {error warning data}}
			validationErrors {error warning data}
			properties {
				items {validationErrors {error warning data}}
				validationErrors {error warning data}
				properties {
					items {validationErrors {error warning data}}
					validationErrors {error warning data}
					properties {
						items {validationErrors {error warning data}}
						validationErrors {error warning data}
						properties {
							items {validationErrors {error warning data}}
							validationErrors {error warning data}
						}
					}
				}
			}
		}
	}`,

	taskFragment: `tasks {
		assignees {validationErrors {error warning data}}
		routeCondition {options {validationErrors {error warning data}} validationErrors {error warning data}}
		validationErrors {error warning data}
		tasks {
			assignees {validationErrors {error warning data}}
			routeCondition {options {validationErrors {error warning data}} validationErrors {error warning data}}
			validationErrors {error warning data}
			tasks {
				assignees {validationErrors {error warning data}}
				routeCondition {options {validationErrors {error warning data}} validationErrors {error warning data}}
				validationErrors {error warning data}
				tasks {
					assignees {validationErrors {error warning data}}
					routeCondition {options {validationErrors {error warning data}} validationErrors {error warning data}}
					validationErrors {error warning data}
					tasks {
						assignees {validationErrors {error warning data}}
						routeCondition {options {validationErrors {error warning data}} validationErrors {error warning data}}
						validationErrors {error warning data}
						tasks {
							assignees {validationErrors {error warning data}}
							routeCondition {options {validationErrors {error warning data}} validationErrors {error warning data}}
							validationErrors {error warning data}
						}
					}
				}
			}
		}
	}`,

	// instanceData test samples
	textSingleValid: {string: text1000},
	textSingleInvalid: {string: text1001},
	
	textMultiValid: {string_multi: text1000},
	textMultiInvalid: {string_multi: text2501},
	
	dropdownSingleValid: {dropdown_single: "Option 1"},
	dropdownSingleInvalid: {dropdown_single: "Option X"},
	
	dropdownMultiValid: {dropdown_multi: ["Option 1","Option 2"]},
	dropdownMultiInvalid: {dropdown_multi: ["Option 1","Option X"]},
	
	listSingleValid: {list_single: "Option 1"},
	listSingleInvalid: {list_multi: "Option X"},
	
	listMultiValid: {list_multi: ["Option 1","Option 2"]},
	listMultiInvalid: {list_multi: ["Option 1","Option X"]},
	
	objectValid: {object: {text1a: text1, text1b: text1000}},
	objectInvalid: {object: {text1a: text1001}},
	
	dateValid: {date: "2016-02-28T16:41:41.090Z"},
	dateInvalid: {date: "2016-02-28 16:41"},
	
	numberValid: {number: 0},
	numberInvalid: {number: "x"},
	
	telephoneValid: {telephone: "(555) 555-5555"},
	telephoneInvalid: {telephone: "(555 555-555"},
	
	stateValid: {state: "CA"},
	stateInvalid: {state: "a"},
	
	zipcodeValid: {zipcode: "93012"},
	zipcodeInvalid: {zipcode: "930"},

	// milestone Fragments
	milestoneAddTag: {
		"actionId": "<<UUID>>",
		"type": "add_tag",
		"expression": {
			"typeId": "const::string",
			"type": "string",
			"value": "mtag1",
		}
	},

	milestoneNullType: {
		"actionId": "<<UUID>>",
		"type": null,
		"expression": {
			"typeId": "const::string",
			"type": "string",
			"value": "mtag1",
		}
	},

	milestoneInvalidType: {
		"actionId": "<<UUID>>",
		"type": "add_tagxxx",
		"expression": {
			"typeId": "const::string",
			"type": "string",
			"value": "mtag1",
		}
	},

	milestoneNullExpression: {
		"actionId": "<<UUID>>",
		"type": "add_tag",
		"expression": null,
	},
	
}

export default testfragments
